import raf from 'raf';
import Store from 'core/Store';

function ScrollRaf() {
  let last = null;
  let current = 0;
  let started = false;

  return { listen };

  function listen() {
    window.addEventListener('scroll', onScroll);
    onScroll();
  }

  function onScroll() {
    current = window.scrollY || window.scollTop || document.getElementsByTagName('html')[0].scrollTop;
    if (!started) {
      raf.add(update);
      started = true;
    }
  }

  function update() {
    if (last === null || current !== last) {
      Store.set('scroll', current);
      last = current;
    } else {
      raf.remove(update);
      started = false;
    }
  }
}

export default ScrollRaf;



// WEBPACK FOOTER //
// ./src/js/utilities/scrollRaf.js